const GradientBackground = () => {
  return (
    <div className="absolute inset-0 z-0 top-0 left-0 w-full h-full bg-black">
      <svg
        className="w-full h-full"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="blur150" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="150" />
          </filter>
          <filter id="blur250" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="250" />
          </filter>
          <filter id="blur100" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="100" />
          </filter>
          <filter id="blur90" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="90" />
          </filter>
        </defs>

        <g opacity="0.6" clipPath="url(#clip0)">
          <rect width="1440" height="900" fill="black" />
          {/* Blue */}
          <ellipse cx="1241" cy="544" rx="470" ry="639" fill="#2C00D9" filter="url(#blur150)" />
          {/* Pink */}
          <ellipse
            cx="980.5"
            cy="604.716"
            rx="964.521"
            ry="408.275"
            transform="rotate(9.05178 980.5 674.716)"
            fill="#FF0099"
            filter="url(#blur250)"
          />
          {/* Yellow */}
          <ellipse cx="128" cy="590" rx="572" ry="489" fill="#FF9900" filter="url(#blur90)" />
          {/* Turquoise */}
          <ellipse
            cx="1530.12"
            cy="500.202"
            rx="308"
            ry="203"
            transform="rotate(27.7951 1440.12 628.202)"
            fill="#00FFFF"
            filter="url(#blur100)"
          />
          {/* Brown */}
          <ellipse
            cx="17.4307"
            cy="216.29"
            rx="139"
            ry="352.216"
            transform="rotate(-24.0408 17.4307 216.29)"
            fill="#AB4700"
            filter="url(#blur150)"
          />
        </g>
        <clipPath id="clip0">
          <rect width="1440" height="900" fill="white" />
        </clipPath>
      </svg>
    </div>
  );
};

export default GradientBackground;
